import { SpeakerNotesOutlined as FollowUpIcon } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import { useAuthContext } from "../../../context";
import { SinisterInternalFollowUpService } from "../../../shared/services/api/sinister/SinisterInternalFollowUpService";
import { getFollowUpServiceByContext } from "../../client/components/ModalFollowUpGeneric/FollowUpService";
import { GenericFollowUpTabsModalContent } from "../../client/components/ModalFollowUpGeneric/GenericFollowUpTabsModalContent";
import { handlePermissionSendFollowUp } from "../../sinister/helpers/sinisterHelpers";

interface Props {
	sinisterId: string;
	status: string;
}

const externalFollowUpServices = getFollowUpServiceByContext("sinister");
const internalFollowUpServices = {
	getNotes: (id: string) => SinisterInternalFollowUpService.getSinisterInternalFollowupNotes(id),
	addNote: (id: string, message: string) => SinisterInternalFollowUpService.addSinisterInternalFollowupNote(id, message),
};

export const CreditRecoveryFollowUpButton = ({ sinisterId, status }: Props) => {
	const { loggedUser } = useAuthContext();
	const [openModal, setOpenModal] = useState(false);

	return (
		<>
			<Tooltip title="Follow Up">
				<IconButton size="small" onClick={() => setOpenModal(true)}>
					<FollowUpIcon fontSize="small" color="primary" />
				</IconButton>
			</Tooltip>

			{openModal && (
				<GenericFollowUpTabsModalContent
					open={openModal}
					onClose={() => setOpenModal(false)}
					clientId={sinisterId}
					loggedUser={loggedUser!}
					externalServices={externalFollowUpServices}
					internalServices={internalFollowUpServices}
					permissionSendExternal={handlePermissionSendFollowUp(status)}
					permissionAddContact={true}
					defaultTab="internal"
				/>
			)}
		</>
	);
};
